// 子仓库-养老
import to from 'await-to-js';
import * as apis from "@/api/interface/yanglao";

export default {
  namespaced: true,
  state: () => ({
    loading: {},
    liveClueList: undefined, //直播线索管理-列表
    supplyPlanList: undefined, //供数计划 - 列表
    tkOrderReportList: undefined, //泰康出单概率报表 - 列表
    liveFeedbackList: undefined, //直播反馈 - 列表
    clueIssuedList: undefined, //泰康线索用户加急/投诉反馈 - 下发列表
    materialList: undefined, //素材管理 - 列表
    clueMonitorList: undefined, //小蓝表 - 列表
    budgetList: undefined, //预算管理 - 列表
  }),
  getters: {},
  mutations: {
    update(state, payload) {
      Object.keys(payload).forEach((key) => {
        state[key] = payload[key];
      });
    },
  },
  actions: {
    // 直播线索管理-列表
    async getLiveClueList(ctx, payload = {}) {
      const [err, res] = await to (apis.getLiveClueList(payload));
      ctx.commit("update", {
        liveClueList: !err && res.data ? res.data : undefined,
      });
    },
    // 直播线索管理-选项
    async getLiveClueOptions(ctx, payload = {}) {
      const [, res] = await to (apis.getLiveClueOptions(payload));
      return res;
    },
    // 直播线索管理-互动状态修改
    async liveClueStatusUpdate(ctx, payload = {}) {
      const [, res] = await to(apis.liveClueStatusUpdate(payload));
      return res;
    },
    // 直播线索管理-主播排期模板下载
    async liveClueDownSchduleTemplate(ctx, payload = {}) {
      const [, res] = await to(apis.liveClueDownSchduleTemplate(payload));
      return res;
    },
    // 直播线索管理-数据导出
    async liveClueExport(ctx, payload = {}) {
      const [, res] = await to(apis.liveClueExport(payload));
      return res;
    },
    async exportClues(ctx, payload = {}) {
      const [, res] = await to(apis.exportClues(payload));
      return res;
    },
    // 直播线索管理-上传主播排期表
    async liveClueAnchorSchdueUpload(ctx, payload = {}) {
      const [, res] = await to(apis.liveClueAnchorSchdueUpload(payload));
      return res;
    },


    // 供数计划 - 列表
    async getSupplyPlanList(ctx, payload = {}) {
      const [err, res] = await to (apis.getSupplyPlanList(payload));
      ctx.commit("update", {
        supplyPlanList: !err && res.data ? res.data : undefined,
      });
    },
    // 供数计划 - 机构选项
    async getSupplyPlanOrgOptions(ctx, payload = {}) {
      const [, res] = await to (apis.getSupplyPlanOrgOptions(payload));
      return res;
    },
    // 供数计划 - 新增、修改
    async supplyPlanAddOrUpdate(ctx, payload = {}) {
      const [, res] = await to(apis.supplyPlanAddOrUpdate(payload));
      return res;
    },



    // 泰康出单概率报表 - 列表
    async getTkOrderReportList(ctx, payload = {}) {
      const [err, res] = await to (apis.getTkOrderReportList(payload));
      ctx.commit("update", {
        tkOrderReportList: !err && res.data ? res.data : undefined,
      });
    },



    // 直播反馈 - 列表
    async getLiveFeedbackList(ctx, payload = {}) {
      const [err, res] = await to (apis.getLiveFeedbackList(payload));
      ctx.commit("update", {
        liveFeedbackList: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    // 直播反馈 - 新增查询
    async liveFeedbackQueryAppointment(ctx, payload = {}) {
      const [, res] = await to (apis.liveFeedbackQueryAppointment(payload));
      return res;
    },
    // 直播反馈 - 新增、修改
    async liveFeedbackAddOrUpdate(ctx, payload = {}) {
      const [, res] = await to(apis.liveFeedbackAddOrUpdate(payload));
      return res;
    },



    // 泰康线索用户加急/投诉反馈 - 下发列表
    async getClueIssuedList(ctx, payload = {}) {
      const [err, res] = await to (apis.getClueIssuedList(payload));
      ctx.commit("update", {
        clueIssuedList: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    // 泰康线索用户加急/投诉反馈 - 发送邮件
    async clueIssuedSendMail(ctx, payload = {}) {
      const [, res] = await to (apis.clueIssuedSendMail(payload));
      return res;
    },


    
    // 素材管理 - 列表
    async getMaterialList(ctx, payload = {}) {
      const [err, res] = await to (apis.getMaterialList(payload));
      ctx.commit("update", {
        materialList: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    // 素材管理 - 新增、修改
    async materialAddOrUpdate(ctx, payload = {}) {
      const [, res] = await to(apis.materialAddOrUpdate(payload));
      return res;
    },


    // 线索录入-获取月费
    async getClueYlMonthlyFee(ctx, payload = {}) {
      const [, res] = await to (apis.getClueYlMonthlyFee(payload));
      return res;
    },
    // 线索录入-获取线索详情
    async getClueDetailFromPhone(ctx, payload = {}) {
      const [, res] = await to (apis.getClueDetailFromPhone(payload));
      return res;
    },
    // 线索录入-单条新增
    async addClueEnter(ctx, payload = {}) {
      const [, res] = await to (apis.addClueEnter(payload));
      return res;
    },
    // 线索录入-批量新增
    async batchAddClueEnter(ctx, payload = {}) {
      const [, res] = await to (apis.batchAddClueEnter(payload));
      return res;
    },
    // 线索录入-上传批量添加模板
    async uploadBatchAddClueTemplate(ctx, payload = {}) {
      const [, res] = await to (apis.uploadBatchAddClueTemplate(payload));
      return res;
    },



    // 小蓝表 - 列表
    async getClueMonitorList(ctx, payload = {}) {
      const [err, res] = await to (apis.getClueMonitorList(payload));
      ctx.commit("update", {
        clueMonitorList: !err && res.data ? res.data : undefined,
      });
    },
    // 小蓝表 - 渠道类型选项
    async getClueMonitorChannelTypeOptions(ctx, payload = {}) {
      const [, res] = await to (apis.getClueMonitorChannelTypeOptions(payload));
      return res;
    },
    // 小蓝表 - 数据导出
    async clueMonitorExport(ctx, payload = {}) {
      const [, res] = await to(apis.clueMonitorExport(payload));
      return res;
    },
    // 小蓝表 - 获取录音地址
    async getClueMonitorAudioSrc(_, payload = {}) {
      const [, res] = await to(apis.getClueMonitorAudioSrc(payload));
      return res;
    },



    // 预算管理 - 列表
    async getBudgetList(ctx, payload = {}) {
      const [err, res] = await to (apis.getBudgetList(payload));
      ctx.commit("update", {
        budgetList: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    // 预算管理 - 新增、修改
    async budgetAddOrUpdate(ctx, payload = {}) {
      const [, res] = await to(apis.budgetAddOrUpdate(payload));
      return res;
    },
  },
  modules: {},
};
